import { defineComponent as i, openBlock as r, createBlock as d, unref as l, withCtx as u, renderSlot as a } from "vue";
import s from "./ghl-ui.es323.js";
const p = i({
  name: "UIDropdown",
  inheritAttrs: !1
}), f = i({
  ...p,
  props: {
    trigger: {
      type: String,
      default: "click"
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "medium"
    },
    placement: {
      type: String,
      default: "top"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    renderOption: {
      type: Function,
      default: void 0
    },
    renderLabel: {
      type: Function,
      default: void 0
    },
    renderIcon: {
      type: Function,
      default: void 0
    }
  },
  emits: ["select", "update:show", "clickoutside"],
  setup(e) {
    return (n, t) => (r(), d(l(s), {
      id: e.id,
      trigger: e.trigger,
      options: e.options,
      placement: e.placement,
      size: e.size,
      show: e.show,
      "render-label": e.renderLabel,
      "render-icon": e.renderIcon,
      "render-option": e.renderOption,
      onSelect: t[0] || (t[0] = (o) => n.$emit("select", o)),
      "onUpdate:show": t[1] || (t[1] = (o) => n.$emit("update:show", o)),
      onClickoutside: t[2] || (t[2] = (o) => n.$emit("clickoutside"))
    }, {
      default: u(() => [
        a(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "trigger", "options", "placement", "size", "show", "render-label", "render-icon", "render-option"]));
  }
}), g = f;
export {
  g as default
};
